/**
 * Provider factory. Resolves the active analytics sink(s) once and memoises
 * them.
 *
 * Wisetap is the sole event/profile sink — the CleverTap SDK (and its
 * ANALYTICS_PROVIDER rollback escape hatch) was removed once the Wisetap
 * cutover proved out. Add future providers here.
 */
import { WisetapProvider } from "./providers/WisetapProvider";
import type { AnalyticsProvider } from "./AnalyticsProvider";

let providers: AnalyticsProvider[] | null = null;

/** Active providers (lazy — no construction happens at import time). */
export const getProviders = (): AnalyticsProvider[] => {
  if (!providers) providers = [new WisetapProvider()];
  return providers;
};
